/*
 * pv-section-reveal.js
 *
 * One small entrance-reveal observer shared by the Povellea homepage discovery
 * sections (Shop by Room, Featured Packages). Kept deliberately tiny and
 * dependency-free: the theme has no bundler and no animation library, and a
 * single IntersectionObserver is all these sections need.
 *
 * Contract with the CSS:
 *   [data-pv-reveal]            an element that starts offset and transparent
 *   .pv-reveal--in              added once, when the element first enters view
 *   --pv-reveal-index           per-element stagger step, set in Liquid
 *
 * The reveal runs ONCE per element and then stops being observed, so scrolling
 * back and forth does not re-animate the page.
 *
 * Theme editor safety: every element is stamped with data-pv-reveal-bound the
 * first time it is seen, and the shopify:section:load listener is attached once
 * per page. Re-rendering a section therefore never accumulates observers or
 * duplicate listeners.
 */
(function () {
  'use strict';

  if (window.PvSectionReveal) return;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SUPPORTED = typeof window.IntersectionObserver === 'function';

  function show(el) {
    el.classList.add('pv-reveal--in');
  }

  /* No observer, no motion preference, or a section with motion switched off in
     the theme editor: the content is simply present. Never hidden. */
  function reveal(root) {
    var nodes = root.querySelectorAll('[data-pv-reveal]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-pv-reveal-bound', '');
      show(nodes[i]);
    }
  }

  var observer = null;

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          show(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    return observer;
  }

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-pv-motion]');

    for (var s = 0; s < sections.length; s++) {
      var section = sections[s];
      var off = section.getAttribute('data-pv-motion') === 'off';

      if (off || REDUCED || !SUPPORTED) {
        reveal(section);
        continue;
      }

      var nodes = section.querySelectorAll('[data-pv-reveal]:not([data-pv-reveal-bound])');
      for (var n = 0; n < nodes.length; n++) {
        nodes[n].setAttribute('data-pv-reveal-bound', '');
        getObserver().observe(nodes[n]);
      }
    }
  }

  window.PvSectionReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: a re-rendered section arrives with fresh, unbound nodes. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
